module.exports = "/assets/data/bf358a33e073e127168a64b34e9fe89e-NN15.data.json";